export default __webpack_public_path__ + "static/media/reports.c1248c01.svg";